/* globals $ */

import rangeEvents from './events';

/**
 * Range
 * @param {Element} element
 * @param {Object} settings
 * @return {Object}
 */
const range = (element, settings) => {
  const $element = $(element);
  const $slider = $element.find('[data-js-range-slider]');
  const $currentValue = $element.find('[data-js-range-currentValue]');

  /**
   * Constructor
   */
  function constructor() {
    $slider.slider(settings);
    $currentValue.text(settings.value);

    if (settings.disabled) {
      onDisable();
    }

    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $element
      .on(rangeEvents.ENABLE, onEnable)
      .on(rangeEvents.DISABLE, onDisable);

    $slider
      .on('slide', onSlide)
      .on('slidechange', onSlideChange);
  }

  /**
   * Slide event handler
   */
  function onSlide() {
    const value = $slider.slider('value');
    $currentValue.text(value);
  }

  /**
   * Slide change event handler
   */
  function onSlideChange() {
    const value = $slider.slider('value');

    $currentValue.text(value);
    $element.trigger(rangeEvents.CHANGE, { value });
  }

  /**
   * Enable event handler
   */
  function onEnable() {
    $slider.slider('enable');
    $element.removeClass('_is_disabled');
  }

  /**
   * Disable event handler
   */
  function onDisable() {
    $slider.slider('disable');
    $element.addClass('_is_disabled');
  }

  constructor();

  return {};
};

export default range;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/userLocation/range/range.js